module.exports = __webpack_public_path__ + "static/media/company4.e5e9058e.png";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/pullmanSanAndres/company4.png
// module id = 1221
// module chunks = 0